<form id="siteForm" appPromptUnsubmitted (ngSubmit)="save()">
<div class="row">
    <div class="col-md-6">
        <div class="row">
            <div class="form-group col-sm-4">
                <label for="siteCode">Planting site ID</label>
                <input class="form-control"
                       name="sitecode"
                       id="siteCode"
                       type="text"
                       placeholder="(Autogenerated)"
                       [(ngModel)]="site.code"
                       [disabled]="!currentUser?.permissions.canManagePlantingSites">
            </div>

            <div class="form-group col-sm-8">
                <label for="name">Name of site</label>
                <input class="form-control"
                       name="title"
                       [appIsInvalid]="!site.title"
                       [(ngModel)]="site.title"
                       required
                       id="name"
                       type="text"
                       value="Wonderland"
                       [disabled]="!currentUser?.permissions.canManagePlantingSites">
                <div class="invalid-feedback">
                    Name is Required.
                </div>
            </div>

            <div class="form-group col-sm-6">
                <label for="country">Country</label>
                <div class="autocomplete">
                    <input
                           name="country"
                           [appIsInvalid]="!site.country"
                           [(ngModel)]="site.country"
                           [typeahead]="countries"
                           [typeaheadMinLength]="0"
                           required
                           id="country"
                           class="form-control"
                           [disabled]="!currentUser?.permissions.canManagePlantingSites">
                    <div class="invalid-feedback">
                        Country is Required.
                    </div>
                </div>
            </div>

            <div class="form-group col-sm-6">
                <label for="region">Region/province</label>
                <div class="autocomplete">
                    <input
                           name="region"
                           [appIsInvalid]="!site.region"
                           [(ngModel)]="site.region"
                           [typeahead]="regions"
                           [typeaheadMinLength]="0"
                           required
                           id="region"
                           class="form-control is-invalid"
                           [disabled]="!currentUser?.permissions.canManagePlantingSites">
                    <div class="invalid-feedback">
                        Region is Required.
                    </div>
                </div>
            </div>

            <div class="form-group col-sm-6">
                <label for="date">Year</label>
                <select class="form-control custom-select"
                        name="year"
                        [appIsInvalid]="!siteYear"
                        [(ngModel)]="siteYear"
                        id="date"
                        [disabled]="!currentUser?.permissions.canManagePlantingSites">
                    <option *ngFor="let year of years" [value]="year">{{year}}</option>
                </select>
                <div class="invalid-feedback">
                    Year is Required.
                </div>
            </div>

            <div class="form-group col-6">
                <label for="totalTrees">Total of trees planted in planing(s)</label>
                <!-- <input class="form-control is-invalid"
                       id="totalTrees"
                       type="number"
                       name="totalTrees"
                       [appIsInvalid]="!site.totalTrees ||  site.totalTrees > 999999999 || (site.totalTrees | hasDecimal)"
                       min="0"
                       max="999999999"
                       [(ngModel)]="site.totalTrees"
                       [disabled]="!currentUser?.permissions.canManagePlantingSites">
                <div *ngIf="!site.totalTrees && site.totalTrees !== 0" class="invalid-feedback">
                    No. of planted trees is Required.
                </div>
                <div *ngIf="site.totalTrees <= 0" class="invalid-feedback">
                    Planted trees should be greater than zero
                </div>
                <div *ngIf="site.totalTrees > 999999999" class="invalid-feedback">
                    Planted trees should be less than 1,000,000,000
                </div>
                <div *ngIf="site.totalTrees | hasDecimal" class="invalid-feedback">
                    Planted trees must be an integer value
                </div> -->
                <p class="form-text font-weight-bold">{{site.totalTrees}}</p>
            </div>

            <div class="form-group col-12">
                <label for="name">Location</label>
                <a class="form-control btn-link is-invalid" [appIsInvalid]="!site.lat || !site.lon"
                   (click)="mapModal.show()"
                   [class.disabled]="!currentUser?.permissions.canManagePlantingSites"><i class="icon-location-pin"></i>&nbsp;
                    <ng-container *ngIf="site.lat && site.lon">{{site.lat}}, {{site.lon}}</ng-container>
                </a>
                <div class="invalid-feedback">
                    Site location is Required.
                </div>
                <app-map-picker-modal #mapModal [(lat)]="site.lat" [(lon)]="site.lon"></app-map-picker-modal>
            </div>

            <div class="form-group col-12">
                <label for="name">Description of the site </label>
                <small class="float-right">{{site.description?.length}}</small>
                <textarea class="form-control"
                          [(ngModel)]="site.description"
                          id="description"
                          name="description"
                          rows="3"
                          placeholder="Write a description.."
                          [disabled]="!currentUser?.permissions.canManagePlantingSites"></textarea>
            </div>

            <div class="form-group col-12">
                <label for="singledonor">Single donor message </label>
                <small class="float-right">{{site.singleDonorMessage?.length}}</small>
                <textarea class="form-control"
                          [(ngModel)]="site.singleDonorMessage"
                          id="singledonor"
                          name="singledonor"
                          rows="3"
                          placeholder="Content.."
                          [disabled]="!currentUser?.permissions.canManagePlantingSites"></textarea>
            </div>

            <div class="form-group col-sm-12">
                <div class="row line mt-2">
                    <div class="col-md-6">
                        <h5>Banner</h5>
                    </div>
                </div>
            </div>
            <div class="form-group col-sm-12">
                <div class="custom-control custom-checkbox checkbox">
                    <input
                           id="enable-banner"
                           type="checkbox"
                           class="custom-control-input"
                           [checked]="site.enabledBanner"
                           (click)="toggleBanner()"
                           [disabled]="!currentUser?.permissions.canManagePlantingSites">
                    <label class="custom-control-label" for="enable-banner">Enable banner</label>
                </div>
            </div>
            <div class="form-group col-sm-12">
                <label for="bannderHeading">Heading</label>
                <input class="form-control"
                        name="bannerheading"
                        id="bannderHeading"
                        type="text"
                        [(ngModel)]="site.bannerHeader"
                        [disabled]="!currentUser?.permissions.canManagePlantingSites">
            </div>
            <div class="form-group col-12">
                <label for="singledonor">Description</label>
                <small class="float-right">{{site.bannerDescription?.length}}</small>
                <textarea class="form-control"
                          [(ngModel)]="site.bannerDescription"
                          id="singledonor"
                          name="singledonor"
                          rows="3"
                          placeholder="Content.."
                          [disabled]="!currentUser?.permissions.canManagePlantingSites"></textarea>
            </div>

            <div class="form-group col-sm-12">
                <div class="row line mt-2">
                    <div class="col-md-6">
                        <h5>Community owner</h5>
                    </div>
                    <div class="col-md-6">
                        <button type="button" class="btn btn-primary" style="float: right;"
                            (click)="openModal(true,true)" [style.display]="site?.landOwner ? 'none' : 'block'"
                            *ngIf="currentUser?.permissions.canManagePlantingSites">
                            Add
                        </button>
                    </div>
                </div>
            </div>
            <div class="form-group col-sm-12" *ngIf="site?.landOwner">
                <table class="table table-borderless table-general-info">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th class="image-icon">Image</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td> <input class="form-control" type="text" value="{{site.landOwner}}" disabled></td>
                        <td> <input class="form-control" type="text" value="{{site.landOwnerDescription}}" disabled> </td>
                        <td class="table-button text-center vertical-middle">
                            <ng-container *ngIf="site.landOwnerPhoto?.originalUrl|| site.newLandOwnerPhoto; else noPhoto">
                                <a class="edit" title="Image"><i class="icon-picture have-image"></i></a>
                            </ng-container>
                            <ng-template #noPhoto>
                                -
                            </ng-template>
                        </td>
                        <td class="table-button text-left vertical-middle">
                            <a *ngIf="currentUser?.permissions.canManagePlantingSites"
                                class="edit" (click)="openModal(true,false)" title="Edit">
                                <i class="icon-note"></i></a>
                            <a *ngIf="currentUser?.permissions.canManagePlantingSites"
                                class="delete" (click)="deleteLandOwner()" title="Delete">
                                <i class="icon-trash"></i></a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="form-group col-sm-12">
                <div class="row line mt-2">
                    <div class="col-md-6">
                        <h5>Planting partners</h5>
                    </div>
                    <div class="col-md-6">
                        <button type="button" class="btn btn-primary" style="float: right;"
                            (click)="openModal(false,true)"
                            *ngIf="currentUser?.permissions.canManagePlantingSites">
                            Add
                        </button>
                    </div>
                </div>
            </div>

            <div class="form-group col-sm-12" *ngIf="site?.partners">
                <table class="table table-borderless table-general-info">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th class="image-icon">Image</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of site?.partners">
                            <td> <input class="form-control" type="text" value="{{item.partnerName}}" disabled></td>
                            <td> <input class="form-control" type="text" value="{{item.description}}" disabled></td>
                            <td  class="table-button text-center vertical-middle">
                                <ng-container *ngIf="item.photo; else noPhoto">
                                    <a class="edit" title="Image"><i class="have-image icon-picture"></i></a>
                                </ng-container>
                                <ng-template #noPhoto>
                                    -
                                </ng-template>
                            </td>
                            <td class="table-button text-left vertical-middle">
                                <a *ngIf="currentUser?.permissions.canManagePlantingSites"
                                    class="edit" (click)="openModal(false,false,item)" title="Edit">
                                    <i class="icon-note"></i></a>
                                <a *ngIf="currentUser?.permissions.canManagePlantingSites"
                                    class="delete" (click)="deletePlantingPartner(item.ngoPartnerId)" title="Delete">
                                    <i class="icon-trash"></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="col-md-6">
        <div class="row">
            <div class="form-group col-md-12">
                <label for="name">Top banner</label>
                <app-photo-upload [existingPhotoUrl]="site.headerPhoto?.originalUrl" *ngIf="!isSaving"
                                  [photoPosition]="site.photoPosition"
                                  (photoSelected)="onPhotoSelected($event)"
                                  [isDisabled]="!currentUser?.permissions.canManagePlantingSites"></app-photo-upload>

                <div class="form-inline mt-3">
                    <div class="form-group" *ngIf="currentUser?.permissions.canManagePlantingSites">
                        <label class="mr-3">Background position</label>
                        <div class="btn-group">
                            <label class="btn btn-primary"
                                   [(ngModel)]="site.photoPosition"
                                   [btnRadio]="1"
                                   tabindex="0"
                                   name="top"
                                   role="button">Top</label>
                            <label class="btn btn-primary"
                                   [(ngModel)]="site.photoPosition"
                                   [btnRadio]="2"
                                   name="mid"
                                   tabindex="0"
                                   role="button">Middle</label>
                            <label class="btn btn-primary"
                                   [(ngModel)]="site.photoPosition"
                                   [btnRadio]="3"
                                   name="bottom"
                                   tabindex="0"
                                   role="button">Bottom</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group col-md-12">
                <label for="name">Upload report for this planting site (PDF)</label>
                <ng-container *ngIf="!isPDFUpload else hasPDFFile">
                    <div class="input-group">
                        <div class="custom-file">
                            <input *ngIf="currentUser?.permissions.canManageUsers"
                                type="file" class="custom-file-input" id="inputGroupPDFFile" (change)="onPDFSelected($event)"
                                accept=".pdf">
                            <label class="custom-file-label btn-file" for="inputGroupPDFFile"
                                aria-describedby="inputGroupFileAddon02"><i class="icon-cloud-upload"></i>
                                Upload file</label>
                        </div>
                    </div>
                    <span class="help-text" *ngIf="pdfErrorSize">Maximum upload file size: 100 MB.</span>
                </ng-container>
                <ng-template #hasPDFFile>
                    <div class="input-group">
                        <input type="text" class="form-control"
                            aria-label="Recipient's username" [value]="pdfFileName" aria-describedby="button-addon2"
                            disabled>
                        <div class="input-group-append">
                            <button *ngIf="currentUser?.permissions.canManageUsers" class="btn btn-danger" type="button" (click)="onFilePDFDelete()"><i class="icon-trash"></i></button>
                        </div>

                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>

<div class="save-button-area">
    <button *ngIf="currentUser?.permissions.canManagePlantingSites" type="submit" form="siteForm" class="btn btn-primary">Save</button>
    <button *ngIf="currentUser?.permissions.canManagePlantingSites" type="button" class="btn btn-outline-dark" (click)="cancel()">Cancel</button>
</div>


</form>
